import fonts from '../assets/fonts';
import palette from '../assets/palette';

export const button = {
    baseStyle: {
        ...fonts.button,
        borderRadius: 0,
    },
    variants: {
        main: {
            backgroundColor: palette.black,
            color: palette.white,

            _disabled: {
                opacity: 0.6,

                ':hover': {
                    color: palette.brand01,
                },
            },
        },
        outline: {
            backgroundColor: 'transparent',
            color: palette.black,
            border: `1px solid ${palette.black}`,
        },
        link: {
            backgroundColor: 'transparent',
            color: palette.white,
        },
    },
};
